import React from 'react';

// TripAdmit Digital Payments brand mark shown in the top nav for accounts that
// belong to a payments company (card 105). Kept as a self-contained component so
// both the desktop and mobile nav bars render the identical lockup, and so the
// gate (isPaymentsCompany) lives with the nav that consumes it.

// Brand palette, matched to the TripAdmit / TipDirect logo lockups. The coral is
// the app's registered brand red (see miniLogo.svg / TripAdmitMobile.svg); teal
// and navy match the TripAdmit wordmark. These are logotype colours, so the teal
// is intentionally the brand hue rather than a WCAG-tuned text colour.
const BRAND = {
  teal: '#26BFD1',
  navy: '#16243B',
  coral: '#FE424D'
};

// The TripAdmit play-arrow, reusing the exact geometry of the app's miniLogo
// brand glyph. A single geometric mark (not a decorative illustration), rendered
// in brand coral.
function BrandArrow({ size }) {
  return (
    <svg
      width={size}
      height={size * (20 / 17)}
      viewBox="0 0 17 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      style={{ flexShrink: 0 }}>
      <path
        d="M16.76 9.12c.46.844.15 1.902-.696 2.363L2.575 18.835A1.742 1.742 0 0 1 0 17.306l.001-5.238 3.367.076.039 2.082a.553.553 0 0 0 .26.447c.156.1.34.11.508.033l8.232-3.974a.48.48 0 0 0 .269-.465.534.534 0 0 0-.29-.477L3.97 5.45a.517.517 0 0 0-.508.01.499.499 0 0 0-.24.436l.053 2.083-3.275-.072L0 2.695c0-.23.046-.458.134-.67l.074-.155a1.742 1.742 0 0 1 2.36-.709L16.055 8.42c.298.16.542.403.704.7z"
        fill={BRAND.coral}
      />
    </svg>
  );
}

// compact = icon + short "Payments" label (mobile, tight corner cell).
// full     = icon + two-line "TripAdmit / Digital Payments" lockup (desktop).
export function PaymentsBadge({ compact = false }) {
  return (
    <div
      title="TripAdmit Digital Payments"
      aria-label="TripAdmit Digital Payments"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: compact ? 6 : 9,
        userSelect: 'none',
        whiteSpace: 'nowrap',
        fontFamily: 'Montserrat, Arial, sans-serif'
      }}>
      <BrandArrow size={compact ? 15 : 19} />
      {compact ? (
        <span
          style={{
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            color: BRAND.navy
          }}>
          Payments
        </span>
      ) : (
        <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
          <span style={{ fontSize: 14, fontWeight: 700, letterSpacing: '-0.01em' }}>
            <span style={{ color: BRAND.teal }}>Trip</span>
            <span style={{ color: BRAND.navy }}>Admit</span>
          </span>
          <span
            style={{
              fontSize: 8.5,
              fontWeight: 600,
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              color: BRAND.navy,
              opacity: 0.72,
              marginTop: 2
            }}>
            Digital Payments
          </span>
        </span>
      )}
    </div>
  );
}

export default PaymentsBadge;
